import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import productCard from '../snippets/product-card';

export const initProductGrid = () => {
  const sliders = document.querySelectorAll('.product-grid__container');
  if (sliders.length == 0) return;

  sliders?.forEach((slider) => {
    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetAfter: 16,
      loop: false,
      navigation: {
        nextEl: '.product-grid__swiperBtn .swiper-btn-next',
        prevEl: '.product-grid__swiperBtn .swiper-btn-prev',
        disabledClass: 'pointer-events-none opacity-50',
      },
      watchOverflow: true,
      breakpoints: {
        320: {
          slidesPerView: 1.32,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.8,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
        1536: {
          slidesPerView: 4.18,
          spaceBetween: 32,
        },
      },
      on: {
        afterInit: function () {
          slider
            .querySelector('.product-grid__wrapper')
            ?.classList.remove('gap-4', 'lg:gap-6', 'xl:gap-8');
        },
      },
    };
    new Swiper(slider, swiperOptions);
  });

  productCard.initialiseEvents('.product-grid__container');
};
